export const environment = {
    production: false,
    environmentName: 'test',
    storagePrefix: 'fsp_web_app',
    title: '🟢 Fire Survey Pro',
    apiUrl: 'https://test2.api.hickwood.uk/api/v1',
    webPath: 'https://test2.api.hickwood.uk',
    localPath: 'https://test2.web.hickwood.uk',
    sentryDSN: 'https://1942885698bd421ba0b878f01d9fa46b@o1040403.ingest.sentry.io/4505156119232512',
    sentryEnabled: true,
    sentryTracesSampleRate: 1.0,
    sentryProfileSessionSampleRate: 1.0,
    webEnum: '01hrzez5d73snkrggr6wjwtg0f',
    pusher: {
        key: '0a68e498241a156d1ee9',
        cluster: 'eu',
    },
    hotjar: {
        siteId: 5143912,
        version: 6
    },
    launchDarkly: {
        clientId: '6756224a7ab7bf09851dd034',
    }
};
